module.exports = __webpack_public_path__ + "static/media/IMG_4482.6a486453.jpg";